import type { GQL_ID } from '@@partner:types:graphql'

import React, { useCallback } from 'react'
import { useAvailableShopsQuery } from '@@partner:graphql/query/catalog/availableShops.gql'

import { Checkbox, CheckboxGroup, CheckPicker } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import ShopLabel from './shop/ShopLabel'

export interface ProductShopsSelectorProps {
  value?: GQL_ID[]
  onChange?: (selectedShopIds: GQL_ID[]) => void
}

export default function ProductShopsSelector ({
  value = [],
  onChange
}: ProductShopsSelectorProps) {
  const { data, error } = useAvailableShopsQuery()

  const handleShopsChange = useCallback(
    (ids = []) => {
      onChange?.(ids)
    },
    [ onChange ]
  )

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Не удалось загрузить список магазинов"
        error={error}
      />
    )
  }

  return (
    <div>
      <CheckPicker
        value={value}
        data={data?.shops ?? []}
        onChange={handleShopsChange}
        searchable={true}
        placeholder='Магазины'
        valueKey='id'
        labelKey='address'
      />
      
    </div>
  )
}
